import Blacklist from '@/views/admin/Blacklist.vue';
import BlacklistAdd from '@/views/admin/BlacklistAdd.vue';
import BlacklistEdit from '@/views/admin/BlacklistEdit.vue';
import DailyReport from '@/views/admin/DailyReport.vue';
import OccupancyReport from '@/views/admin/OccupancyReport.vue';
import Dashboard from '@/views/admin/Dashboard.vue';
import HolidayAdd from '@/views/admin/HolidayAdd.vue';
import HolidayEdit from '@/views/admin/HolidayEdit.vue';
import HolidayImport from '@/views/admin/HolidayImport.vue';
import HolidayList from '@/views/admin/HolidayList.vue';
import Overbooked from '@/views/admin/Overbooked.vue';
import Reports from '@/views/admin/Reports.vue';
import ReservationEdit from '@/views/admin/ReservationEdit.vue';
import Reservations from '@/views/admin/Reservations.vue';
import RoomAdd from '@/views/admin/RoomAdd.vue';
import RoomEdit from '@/views/admin/RoomEdit.vue';
import RoomEditImage from '@/views/admin/RoomEditImage.vue';
import RoomList from '@/views/admin/RoomList.vue';
import TimeSlotAdd from '@/views/admin/TimeSlotAdd.vue';
import TimeSlotEdit from '@/views/admin/TimeSlotEdit.vue';
import TimeSlotEditMultiCapacity from '@/views/admin/TimeSlotEditMultiCapacity.vue';
import TimeSlotList from '@/views/admin/TimeSlotList.vue';
import TimeSlotBook from '@/views/admin/TimeSlotBook.vue';
import { RouteRecordRaw } from 'vue-router';


export default [
  {
    path: '/',
    component: Dashboard
  },
  {
    path: '/rooms',
    component: RoomList
  },
  {
    path: '/room-add',
    component: RoomAdd
  },
  {
    path: '/room-edit/:id',
    name: 'admin-room-edit',
    component: RoomEdit
  },
  {
    path: '/room-edit-image/:id',
    name: 'admin-room-edit-image',
    component: RoomEditImage
  },
  {
    path: '/room/:id/time-slots',
    name: 'admin-time-slots',
    component: TimeSlotList
  },
  {
    path: '/room/:id/time-slot-add',
    name: 'admin-time-slot-add',
    component: TimeSlotAdd
  },
  {
    path: '/room/:roomId/time-slot-edit/:timeSlotId',
    name: 'admin-time-slot-edit',
    component: TimeSlotEdit
  },
  {
    path: '/room/:roomId/time-slot-edit-multi-capacity/',
    name: 'admin-time-slot-edit-multi-capacity',
    component: TimeSlotEditMultiCapacity
  },
  {
    path: '/room/:roomId/time-slot-book/:timeSlotId',
    name: 'admin-time-slot-book',
    component: TimeSlotBook
  },
  {
    path: '/reservations',
    component: Reservations
  },
  {
    path: '/reservations/:id',
    name: 'admin-reservation-edit',
    component: ReservationEdit
  },
  {
    path: '/holiday-list',
    name: 'admin-holiday-list',
    component: HolidayList
  },
  {
    path: '/holiday-add',
    name: 'admin-holiday-add',
    component: HolidayAdd
  },
  {
    path: '/holiday-import',
    name: 'admin-holiday-import',
    component: HolidayImport
  },
  {
    path: '/holiday-edit/:id',
    name: 'admin-holiday-edit',
    component: HolidayEdit
  },
  {
    path: '/overbooked',
    component: Overbooked
  },
  {
    path: '/blacklist',
    name: 'admin-blacklist',
    component: Blacklist
  },
  {
    path: '/blacklist-add',
    name: 'admin-blacklist-add',
    component: BlacklistAdd
  },
  {
    path: '/blacklist-edit/:email',
    name: 'admin-blacklist-edit',
    component: BlacklistEdit
  },
  {
    path: '/reports',
    component: Reports
  },
  {
    path: '/occupancy-report',
    name: 'admin-occupancy-report',
    component: OccupancyReport
  },
  {
    path: '/daily-report/:id',
    name: 'admin-daily-report',
    component: DailyReport
  },
  {
    path: '/:fallback(.*)*',
    redirect: '/'
  }
] as Array<RouteRecordRaw>;




